import { render, staticRenderFns } from "./CreateSellerFooter.vue?vue&type=template&id=09727b52&"
import script from "./CreateSellerFooter.vue?vue&type=script&lang=js&"
export * from "./CreateSellerFooter.vue?vue&type=script&lang=js&"
import style0 from "./CreateSellerFooter.vue?vue&type=style&index=0&id=09727b52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports